import { render, staticRenderFns } from "./staffRole.vue?vue&type=template&id=4c1cf4b2&scoped=true&"
import script from "./staffRole.vue?vue&type=script&lang=js&"
export * from "./staffRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cf4b2",
  null
  
)

export default component.exports